import { render, staticRenderFns } from "./file-table.vue?vue&type=template&id=70f4d5f8&scoped=true"
import script from "./file-table.vue?vue&type=script&lang=js"
export * from "./file-table.vue?vue&type=script&lang=js"
import style0 from "./file-table.vue?vue&type=style&index=0&id=70f4d5f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f4d5f8",
  null
  
)

export default component.exports